module.exports = __webpack_public_path__ + "static/media/  (103).cbdee2c1.jpg";